import React from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import CampaignAccommodationList from "./CampaignAccommodationList";

const CampaignAccommodation = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  // Determine current source (default to 'campaign')
  const currentSource = searchParams.get("source") || "campaign";

  return (
    <div>
      <PageHeader title={t("CAMPAIGN_SETTLEMENT")} sticky={false} />
      <Container fluid>
        <div className="my-4">
          <CampaignAccommodationList port="JED" source={currentSource} />
        </div>
      </Container>
    </div>
  );
};

export default CampaignAccommodation;
